export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Editable business info (placeholders — owner can update later)
export const BUSINESS = {
  name: "BID Dryer Vent Cleaning",
  short: "BID DVC",
  phone: "(904) 806-4291",
  phoneRaw: "9048064291",
  email: "BIDDVC@gmail.com",
  address: "St. Augustine, FL 32086",
  city: "St. Augustine, FL",
  squareSiteUrl: "https://bid-dvc.square.site/",
  squareBookingUrl: "https://bid-dvc.square.site/",
  squareEmbedUrl: "/square-embed.html",
  hours: "Mon–Fri 9am–5pm · Sat 9am–2pm · Sun Closed",
  hoursDetailed: [
    { day: "Monday", hours: "9:00 am – 5:00 pm" },
    { day: "Tuesday", hours: "9:00 am – 5:00 pm" },
    { day: "Wednesday", hours: "9:00 am – 5:00 pm" },
    { day: "Thursday", hours: "9:00 am – 5:00 pm" },
    { day: "Friday", hours: "9:00 am – 5:00 pm" },
    { day: "Saturday", hours: "9:00 am – 2:00 pm" },
    { day: "Sunday", hours: "Closed" },
  ],
  logoUrl:
    "https://images.editor.website/uploads/b/f3af3100-e0bb-11eb-807c-d9939fc9e567/fdac3564879a8ed4b30c337b1eeaf4da.jpeg?width=400",
  googleMapsUrl: "https://maps.app.goo.gl/rC91WYgrFMVxuxDr7",
  googleRating: 4.9,
  googleCategory: "Air duct cleaning service",

  // Paste your Square "Add to website" embed snippet between the backticks below.
  // Square Dashboard → Appointments → Online Booking → Add to website → Embed code
  // Supports either <script>...</script> or <iframe>...</iframe> snippets.
  squareEmbedHtml: `<!-- Start Square Appointments Embed Code --><script src='https://square.site/appointments/buyer/widget/or8npp5101xorr/LJS575BC43SDK.js'></script><!-- End Square Appointments Embed Code -->`,
};

export const ROOF_OPTIONS = [
  {
    id: "shingle",
    label: "Shingle Roof",
    description: "Most common asphalt shingle roofing.",
    image:
      "https://images.unsplash.com/photo-1603517431529-6ba96d7525bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxzaGluZ2xlcyUyMHJvb2Z8ZW58MHx8fHwxNzgxMjA3MzA0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "tile",
    label: "Tile Roof",
    description: "Clay or concrete tile — extra care required.",
    image:
      "https://images.unsplash.com/photo-1519115226133-94046df0e272?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHx0aWxlJTIwcm9vZiUyMGhvdXNlfGVufDB8fHx8MTc4MTIwNzI5NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "metal",
    label: "Metal Roof",
    description: "Standing seam or panel metal roofing.",
    image:
      "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMHJvb2YlMjBob3VzZXxlbnwwfHx8fDE3ODEyMDcyOTR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "sidewall",
    label: "Side Wall Exit",
    description: "Vent exits through the side wall (no roof access).",
    image:
      "https://images.unsplash.com/photo-1605276373954-0c4a0dac5b12?crop=entropy&cs=srgb&fm=jpg&ixid=M3wzNzc2NTV8MHwxfHNlYXJjaHwxfHxleHRlcmlvciUyMHdhbGwlMjBkcnllciUyMHZlbnR8ZW58MHx8fHwxNzgxMjA3Mjk0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HOUSE_OPTIONS = [
  {
    id: "one_story",
    label: "1-Story Home",
    description: "Single-story house, easy roof access.",
    image:
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxzdWJ1cmJhbiUyMGhvdXNlfGVufDB8fHx8MTc4MTIwNzMwNHww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "two_story",
    label: "2-Story Home / Townhouse",
    description: "Two-story house or attached townhouse — taller vent access.",
    image:
      "https://images.unsplash.com/photo-1647579350413-a6ada4e480ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx0d28lMjBzdG9yeSUyMGhvdXNlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgxMjA3Mjk0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "condo",
    label: "Condo / Apartment",
    description: "Multi-family condo unit or apartment.",
    image:
      "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb25kbyUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzgxMjA3Mjk0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1626806819282-2c1dc01a5e0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjbGVhbiUyMGxhdW5kcnklMjByb29tJTIwaG91c2V8ZW58MHx8fHwxNzgxMjA3Mjk0fDA&ixlib=rb-4.1.0&q=85";
